<template>
	<div
		class="h-screen fixed overflow-y-scroll top-0 right-0 z-40 select-none w-full transition-colors transform-gpu ease-in-out duration-500 bg-local backdrop-blur"
		:class="show ? 'bg-magnolia-100/80' : '-translate-y-full'"
		@click="$emit('hide')"
	>
		<div @click.stop class="flex w-full justify-center py-8 xs:py-12 px-8 bg-ihh-white">
			<div
				class="flex flex-col w-full max-w-2xl h-full justify-center items-center space-y-6 top-0 transform transition-transform duration-300 ease-in-out"
				:class="show ? '' : '-translate-y-full'"
			>
				<div class="flex w-full justify-end">
					<button @click="$emit('hide')" class="group py-2">
						<div class="m-auto items-center flex w-full justify-center">
							<div class="rotate-45 absolute rounded bg-ihh-slate-gray group-hover:bg-ihh-dark-salmon py-px px-2.5"></div>
							<div class="-rotate-45 rounded bg-ihh-slate-gray group-hover:bg-ihh-dark-salmon py-px px-2.5"></div>
						</div>
					</button>
				</div>

				<!-- Dropdown Search Bar -->
				<div class="text-ihh-midnight-gray font-semibold flex w-full justify-center text-center text-2xl">Search products and birth kits</div>

				<div class="flex w-full group rounded-lg text-sm bg-gradient-to-b from-ihh-pink to-ihh-purple font-thin text-black rounded-lg">
					<input
						type="text"
						id="name"
						ref="search"
						v-model="search.value"
						required
						class="px-3 mr-1 z-10 bg-transparent rounded-lg focus:border focus:border-ihh-dark-salmon focus:outline-0 focus:shadow shadow-ihh-dark-salmon w-full text-sm font-light text-black placeholder-ihh-gray relative"
						placeholder="Search the store"
					/>
					<button class="duration-100 transition bg-transparent hover:bg-ihh-salmon/40 rounded-r-lg right-0 p-3">
						<img src="/images/ob-search0129.svg" class="w-5 h-5 duration-300 transition ease-in-out" alt="Search Icon" />
					</button>
				</div>
			</div>
		</div>

		<div v-if="search?.value" class="w-full p-4 md:p-8 flex items-center justify-center">
			<Spinner v-if="search.loading" :small="true" class="w-8 h-8" />
			<div v-else class="max-w-5xl">
				<div v-if="!search.categories?.length && !search.results?.length" class="text-center text-ihh-midnight-gray text-lg font-light">
					No results found for "{{ search.value }}"
				</div>
				<!-- <Product v-for="p in search.results.filter(r => r.collection == 'categories')" :key="p.id" :product="p" class="w-full" /> -->
				<div v-if="search.categories?.length" class="mb-8 pb-8 md:mb-16 md:pb-16 border-b">
					<div class="uppercase tracking-widest text-xl text-black mb-4 text-center md:text-left">Categories</div>
					<div class="w-full grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
						<router-link
							@click="hoverMenu = null"
							class="relative group cursor-pointer flex flex-col w-full aspect-square justify-center bg-magnolia-50/60 shadow rounded-xl items-center p-2 lg:p-6 overflow-hidden product-card"
							v-for="link in search.categories"
							:key="link.url.path"
							:to="`/categories${link.url?.path}`"
						>
							<div
								class="relative group cursor-pointer flex w-full justify-center bg-ihh-light-purple group-hover:border-2 border-ihh-midnight-gray rounded-xl items-center p-1 overflow-hidden"
							>
								<div class="w-full bg-center bg-contain aspect-square mix-blend-darken rounded-lg" :style="`background-image: url(${link.imageUrl})`" />
							</div>
							<div class="flex w-full justify-center mt-2 text-sm flex-col md:flex-row">
								<div class="text-center font-semibold tracking-wide text-ihh-midnight-gray break-words">{{ link.name }}</div>
							</div>
						</router-link>
					</div>
				</div>
				<div v-if="search.results?.length">
					<div class="uppercase tracking-widest text-xl text-black mb-4 text-center md:text-left">Products</div>
					<div class="w-full grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
						<Product v-for="p in search.results" :key="p.id" :product="p" class="w-full" :navigate="navigate" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Mango from '../../helpers/mango'
import Product from '../products/product.vue'

export default {
	components: { Product },
	inject: ['store'],
	props: {
		show: { type: Boolean },
		categoriesEnabled: { default: true },
		searchValue: { default: null },
	},
	data() {
		return {
			search: {
				activeIndex: 0,
				value: null,
				results: [],
				categories: [],
				loading: false,
			},
		}
	},
	watch: {
		// Add a SLIGHT delay when opening for the first time
		hoverMenu(n) {
			if (!n) return (this.confirmedHoverMenu = n)
			if (this.confirmedHoverMenu) return (this.confirmedHoverMenu = n)
			setTimeout(() => {
				if (n == this.hoverMenu) return (this.confirmedHoverMenu = n)
			}, 100)
		},
		show() {
			if (this.show) {
				this.freeze()
				this.$nextTick(() => {
					this.$refs.search.focus()
					// this.$refs.search.select()
				})
			} else {
				this.thaw()
				this.search.results = []
				this.search.value = null
				this.search.categories = []
			}
		},
		'search.value': {
			async handler(n) {
				this.debounceSearch()
			},
		},
		searchValue(newVal) {
			if (newVal) {
				this.search.value = newVal
			}
		},
	},
	methods: {
		freeze() {
			this.$nextTick(() => {
				// this.$refs.search?.focus()
				this.fadeIn = true
				document.body.style.overflow = 'hidden'
				document.getElementById('app').setAttribute('aria-hidden', 'true')
				this.$refs?.modal?.setAttribute('aria-modal', 'true')
				this.attachListeners()
			})
		},
		thaw() {
			document.body.style.overflow = ''
			document.getElementById('app').setAttribute('aria-hidden', 'false')
			this.$refs?.modal?.removeAttribute('aria-modal')
		},
		async searchMango() {
			// this.search.results = (await Mango.products.search(this.search.value, {limit: 20}, 'isVisible:true AND availability:available'))?.hits
			this.search.loading = true
			if (this.categoriesEnabled)
				Mango.search(this.search.value, { limit: 5 }, 'isVisible:true AND collection:categories')
					.then((r) => (this.search.categories = r))
					.finally((r) => (this.search.loading = false))
			// Mango.search(this.search.value, { limit: 25 }, `isVisible:true AND availability:available${this.store.editingKit?.id ? ` AND NOT collection:birthKits` : ''}`)
			Mango.search(
				this.search.value,
				{ limit: 25 },
				`isVisible:true AND NOT categories:66d8b83f6e195ee1d5e056a3${this.store.editingKit?.id ? ` AND NOT collection:birthKits` : ''}`,
			)
				.then((r) => (this.search.results = r))
				.finally((r) => (this.search.loading = false))
		},
	},
	computed: {
		debounceSearch() {
			// return (...args) => {
			//     clearTimeout(this.searchTimeout);
			//     this.searchTimeout = setTimeout(() => { this.searchMango.apply(this, args) }, 500);
			// };
			return () => {
				clearTimeout(this.searchTimeout)
				this.searchTimeout = setTimeout(() => {
					this.searchMango()
				}, 500)
			}
		},
	},
}
</script>

<style></style>
